import { render, staticRenderFns } from "./HistoryChange.vue?vue&type=template&id=366383f9"
import script from "./HistoryChange.vue?vue&type=script&lang=js"
export * from "./HistoryChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports